// ListagemBanco.js
import { useEffect, useState } from "react";
import Carregamento from "../components/Carregamento/Carregamento";
import ColunaBancoDestino from '../components/ColunaBancoDestino/ColunaBancoDestino';
import bancoService from '../services/EndBancoService';
import NotificacaoUtils from '../utils/NotificacaoUtils';
import "./Cadastros.css";

export default function ListagemBanco() {
  const [isLoading, setIsLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);

  const [bancosStandard, setBancosStandard] = useState([]);
  const [bancosPremium, setBancosPremium] = useState([]);
  const [bancosCorporativo, setBancosCorporativo] = useState([]);
  const [bancosAcesso, setBancosAcesso] = useState([]);
  const [bancosChamado, setBancosChamado] = useState([]);

  const [selecionadoStandard, setSelecionadoStandard] = useState(null);
  const [selecionadoPremium, setSelecionadoPremium] = useState(null);
  const [selecionadoCorporativo, setSelecionadoCorporativo] = useState(null);
  const [selecionadoAcesso, setSelecionadoAcesso] = useState(null);
  const [selecionadoChamado, setSelecionadoChamado] = useState(null);

  const SISTEMAS = {
    PONTO: 1,
    ACESSO: 2,
    CHAMADO: 3
  };

  const PLANOS = {
    STANDARD: 1,
    PREMIUM: 2,
    CORPORATIVO: 3
  };

  const listarBancos = async () => {
    setIsLoading(true);
    try {
      const response = await bancoService.listarConfiguracoes();

      if (response && response.data) {
        const dados = response.data;

        // 1 - Ponto
        if (dados[SISTEMAS.PONTO]) {
          const ponto = dados[SISTEMAS.PONTO];
          if (ponto[PLANOS.STANDARD]) {
            setBancosStandard(ponto[PLANOS.STANDARD]);
            setSelecionadoStandard(ponto[PLANOS.STANDARD].find(banco => banco.geracaoAtual === true) || null);
          }
          if (ponto[PLANOS.PREMIUM]) {
            setBancosPremium(ponto[PLANOS.PREMIUM]);
            setSelecionadoPremium(ponto[PLANOS.PREMIUM].find(banco => banco.geracaoAtual === true) || null);
          }
          if (ponto[PLANOS.CORPORATIVO]) {
            setBancosCorporativo(ponto[PLANOS.CORPORATIVO]);
            setSelecionadoCorporativo(ponto[PLANOS.CORPORATIVO].find(banco => banco.geracaoAtual === true) || null);
          }
        }

        // 2 - Acessos
        if (dados[SISTEMAS.ACESSO]) {
          const acessosList = Object.values(dados[SISTEMAS.ACESSO]).flat();
          setBancosAcesso(acessosList);
          setSelecionadoAcesso(acessosList.find(banco => banco.geracaoAtual === true) || null);
        }

        // 3 - Chamados
        if (dados[SISTEMAS.CHAMADO]) {
          const chamadosList = Object.values(dados[SISTEMAS.CHAMADO]).flat();
          setBancosChamado(chamadosList);
          setSelecionadoChamado(chamadosList.find(banco => banco.geracaoAtual === true) || null);
        }
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const salvarConfiguracaoBanco = async (item) => {
    setSalvando(true);
    try {
      const dadosParaSalvar = {
        idEndereco: item.idEndereco,
        descricao: item.titulo,
        idPlano: item.idPlano,
        idTipoSistema: item.idTipoSistema,
        geracaoAtual: item.geracaoAtual
      };

      const response = await bancoService.salvarConfiguracao(dadosParaSalvar);

      if (response.success) {
        NotificacaoUtils.sucesso("Configuração salva com sucesso!");
        await listarBancos();
      } else {
        NotificacaoUtils.erro("Erro ao salvar configuração");
      }
    } catch (error) {
      NotificacaoUtils.erro("Erro ao salvar configuração");
    } finally {
      setSalvando(false);
    }
  };

  const handleSelecionarBanco = async (item, tipo) => {
    switch (tipo) {
      case 'standard': setSelecionadoStandard(item); break;
      case 'premium': setSelecionadoPremium(item); break;
      case 'corporativo': setSelecionadoCorporativo(item); break;
      case 'acesso': setSelecionadoAcesso(item); break;
      case 'chamado': setSelecionadoChamado(item); break;
      default: break;
    }
    await salvarConfiguracaoBanco(item);
  };

  useEffect(() => {
    listarBancos();
  }, []);

  if (isLoading) return <Carregamento />;

  const formatarParaColuna = (bancos) => {
    return bancos.map(banco => ({
      idEndereco: banco.idEndereco,
      titulo: banco.descricao,
      idPlano: banco.idPlano,
      idTipoSistema: banco.idTipoSistema,
      geracaoAtual: banco.geracaoAtual
    }));
  };

  return (
    <>
      <h1 className="cabecalho-padrao-titulo">
        Banco Destino para Novas Bases
      </h1>
      <h2 className="subtitulo-h2-esquerda">
        Defina para qual banco de dados a API destinará novas bases de clientes.
      </h2>

      <div className="container-banco">
        <h1 className="title-interno">
          Dixi Ponto
        </h1>
        <hr className="divider" />
        <div className="grid-banco">
          <ColunaBancoDestino
            title={"Standard"}
            subtitle={"Bancos padrões para clientes comuns."}
            values={formatarParaColuna(bancosStandard)}
            selecionado={selecionadoStandard}
            onTap={(item) => handleSelecionarBanco(item, 'standard')}
            groupId="standard"
          />

          <ColunaBancoDestino
            title={"Premium"}
            subtitle={"Bancos destinados a bases maiores."}
            values={formatarParaColuna(bancosPremium)}
            selecionado={selecionadoPremium}
            onTap={(item) => handleSelecionarBanco(item, 'premium')}
            groupId="premium"
          />

          <ColunaBancoDestino
            title={"Corporativo"}
            subtitle={"Banco destinado a clientes corporativos/licitações."}
            values={formatarParaColuna(bancosCorporativo)}
            selecionado={selecionadoCorporativo}
            onTap={(item) => handleSelecionarBanco(item, 'corporativo')}
            groupId="corporativo"
          />
        </div>
      </div>

      <div className="grid-destino">
        <div className="container-banco">
          <h1 className="title-interno">
            Dixi Chamados
          </h1>
          <hr className="divider" />
          <div className="coluna-destino">
            <ColunaBancoDestino
              title={"Standard"}
              values={formatarParaColuna(bancosChamado)}
              selecionado={selecionadoChamado}
              onTap={(item) => handleSelecionarBanco(item, 'chamado')}
              groupId="chamado"
            />
          </div>
        </div>
        <div className="container-banco">
          <h1 className="title-interno">
            Dixi Acessos
          </h1>
          <hr className="divider" />
          <div className="coluna-destino">
            <ColunaBancoDestino
              title={"Standard"}
              values={formatarParaColuna(bancosAcesso)}
              selecionado={selecionadoAcesso}
              onTap={(item) => handleSelecionarBanco(item, 'acesso')}
              groupId="acesso"
            />
          </div>
        </div>
      </div>
    </>
  );
}